// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

/* eslint-disable import/no-extraneous-dependencies */
import 'babel-core/register';
import 'babel-polyfill';

// VUE NATIVE MODULES
import Vue from 'vue';
import VueRouter from 'vue-router';

// VENDOR MODULES MODULES
import VueResource from 'vue-resource';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en';
import 'element-ui/lib/theme-chalk/index.css';

// RELATIVE IMPORTS
import App from './App';
import store from './store';
import router from './router';

// APP DEPENDENCIES
Vue.use(VueRouter);
Vue.use(VueResource);

// TODO:: Use `babel-component-loader` instead loading whole package.
Vue.use(ElementUI, { locale });

// VUE INSTANCE
/* eslint-disable no-new */
new Vue({
  router,
  store,
  components: {
    App,
  },
  template: '<App/>',
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js